import type { CityConfig } from "../city-template/types";

export const elkhartConfig: CityConfig = {
  vitalRecordsIcon: "ri-file-text-line",
  city: "Elkhart",
  state: "Indiana",
  stateAbbr: "IN",
  slug: "elkhart",
  route: "/cities/elkhart",
  title: "Emergency Passport Elkhart IN | Expedited Elkhart County RV Capital | Fast Passport Center",
  metaDescription: "Emergency passport and expedited passport services in Elkhart, Indiana — as fast as 24 hours. Fast passport renewal and new passport applications for Elkhart, Goshen, Mishawaka, Bristol, and all Elkhart County residents. A+ BBB rated courier service.",
  h1: "Emergency & Expedited Passport Services in Elkhart, IN",
  heroSubtitle: "Elkhart travelers — from RV industry professionals heading to international trade shows to Elkhart County families vacationing abroad to Goshen College students studying overseas — trust Fast Passport Center for emergency and expedited passports as fast as 24 hours. A+ BBB rated registered courier serving all of northern Indiana's RV capital region.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Elkhart%20Indiana%20downtown%20with%20the%20Elkhart%20River%20flowing%20through%20the%20city%2C%20historic%20downtown%20buildings%20with%20brick%20architecture%2C%20the%20Wellfield%20Botanic%20Gardens%20at%20twilight%2C%20RV%20manufacturing%20heritage%20reflected%20in%20the%20Midwestern%20industrial%20landscape%2C%20golden%20sunset%20light%20on%20the%20riverfront%2C%20professional%20city%20photography%20with%20warm%20tones%2C%20small%20city%20charm%20combined%20with%20industrial%20character%2C%20no%20text%20or%20people%2C%20editorial%20style%20urban%20photography%20with%20rich%20atmospheric%20lighting&width=1800&height=700&seq=elkhart-hero-001&orientation=landscape",
  heroImageAlt: "Elkhart Indiana downtown with Elkhart River and historic architecture in golden sunset light",
  geoPosition: "41.6870;-85.9767",
  geoPlacename: "Elkhart, Indiana",
  lastModified: "2026-06-08",
  regionalAgency: {
    name: "Chicago Passport Agency",
    address: "101 Ida B Wells Dr, Chicago, IL 60605",
    distance: "Approximately 2 hours west of Elkhart via I-80/90 — about 110 miles",
  },
  nearbyCitiesZips: [
    { name: "Elkhart", zips: "46514, 46515, 46516, 46517" },
    { name: "Goshen", zips: "46526, 46527, 46528" },
    { name: "Mishawaka", zips: "46544, 46545, 46546" },
    { name: "Bristol", zips: "46507" },
    { name: "South Bend", zips: "46601, 46613, 46614, 46615, 46616, 46617, 46619, 46628, 46635, 46637" },
    { name: "Granger", zips: "46530" },
    { name: "Osceola", zips: "46561" },
    { name: "Nappanee", zips: "46550" },
    { name: "Middlebury", zips: "46540" },
    { name: "Wakarusa", zips: "46573" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Registered courier service to Chicago Passport Agency — fastest option in northern Indiana" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting for Elkhart County" },
    { icon: "ri-building-line", title: "RV Industry Hub", desc: "Serving RV manufacturers, suppliers, and Elkhart County business travelers" },
    { icon: "ri-mail-send-line", title: "Document Shipping", desc: "Prepaid overnight labels from any UPS or FedEx in Elkhart, Goshen, or Mishawaka" },
  ],
  internalLinks: [
    { name: "Expedited passport in Fort Wayne, IN", route: "/cities/fort-wayne" },
    { name: "Emergency passport help in Indianapolis, IN", route: "/cities/indianapolis" },
    { name: "Passport services in Carmel, IN", route: "/cities/carmel" },
    { name: "Indiana passport services overview", route: "/states/indiana" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Elkhart, Indiana via secure registered courier. We hand-deliver your documents to U.S. Department of State processing facilities. For Elkhart County travelers, the closest regional passport agency is the Chicago Passport Agency (101 Ida B Wells Dr, Chicago) — approximately 110 miles west via I-80/90. Our courier service eliminates the need for a 2-hour drive through busy Chicago-area traffic.",
  fpcOfficeDistance: "Serving Elkhart, Goshen, Mishawaka, Bristol, South Bend, Granger, Osceola, Nappanee, Middlebury, Wakarusa, and all of Elkhart County",
  serviceAreaIntro: "Fast Passport Center provides emergency and expedited passport services throughout Elkhart and Elkhart County. From the Riverwalk and downtown Elkhart to the RV manufacturing corridor to Goshen College and the surrounding communities — we serve all of northern Indiana's RV capital region.",
  nearbyCitiesIntro: "We serve Elkhart and all nearby communities including Goshen, Mishawaka, Bristol, South Bend, Granger, Osceola, Nappanee, Middlebury, and Wakarusa. We also serve all of Elkhart County and the Michiana region.",
  howItWorksIntro: "Most Elkhart travelers complete everything online and ship documents via overnight courier. Our registered couriers handle the State Department delivery — no need to make the 2-hour drive to Chicago through unpredictable Indiana Toll Road and Chicago Skyway traffic.",
  mistakesIntro: "Elkhart is the RV capital of the world with significant international business travel for trade shows, manufacturing partnerships, and supplier visits. Here are the most common passport mistakes we see from Elkhart County travelers.",
  testimonialsIntro: "Elkhart travelers — from RV industry professionals to Elkhart County families to Goshen College students — trust us when their departure is days away.",
  faqIntro: "Have questions about expedited passports in Elkhart, IN? Here are the most common ones we hear from Elkhart County travelers.",
  statePageRoute: "/states/indiana",
  statePageName: "Indiana",
  dmvWebsite: "https://www.in.gov/bmv",
  dmvLabel: "Indiana BMV — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — no walk-ins allowed", "Life-or-death emergencies only", "Must drive to Chicago Passport Agency (~2 hours each way)", "Chicago traffic unpredictable — plan extra time"],
      highlight: false,
      emergency: true,
    },
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "No Chicago drive required — ship from Elkhart", "Perfect for RV industry trade shows and family vacations", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Faster than self-service", "Good for planned travel and trade shows", "Document review included", "Dedicated agent assigned to your case", "Daily status updates"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "Workload & wait times shift with shutdowns and budget fights", "In-person clerk appointment required", "No document review — errors cause rejection", "No dedicated agent — you are on your own", "Updates only by physical mail letter", "Can't upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For Elkhart travelers with immediate departure needs — as fast as 24 hours. Essential for RV industry professionals heading to international trade shows and urgent business meetings.",
      bullets: ["24–48 hour turnaround available", "Courier handles the 2-hour Chicago drive for you", "RV industry and business travel support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for Elkhart adults with a passport issued within the last 15 years. Skip the post office and let our couriers handle everything from start to finish.",
      bullets: ["No clerk visit required for most renewals", "Mail-in or courier options", "Returned to your Elkhart County address"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport (First-Time)",
      description: "First-time passport application for Elkhart residents and families — including Goshen College students, new citizens, and families in the Michiana region.",
      bullets: ["Acceptance facility scheduling in Elkhart or Goshen", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Emergency passport replacement for Elkhart residents who lost their passport before international travel, trade shows, or family trips.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement in 24–48 hours"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 — for Elkhart and Elkhart County families traveling internationally with children.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change Passport",
      description: "Passport name correction after marriage, divorce, or legal name changes for Elkhart and Elkhart County residents.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Elkhart IN", description: "Urgent passport processing for Elkhart Indiana travelers with immediate departure needs." },
    { name: "Expedited Passport Renewal Elkhart IN", description: "Fast passport renewal for Elkhart Indiana residents with a previously-issued passport." },
    { name: "First-Time Passport Elkhart IN", description: "New passport application services for Elkhart Indiana residents applying for their first passport." },
    { name: "Child Passport Elkhart IN", description: "Minor passport services for Elkhart Indiana families with children under 16." },
  ],
  testimonials: [
    {
      name: "Tom R.",
      location: "Elkhart, IN — Near Riverwalk",
      rating: 5,
      text: "RV trade show in Düsseldorf, Germany in 10 days — realized my passport was expiring in 4 months. Fast Passport Center expedited my renewal in 3 days. Not having to drive to Chicago was a massive relief. Saved the whole trip.",
      service: "Emergency Passport Renewal",
    },
    {
      name: "Maria H.",
      location: "Goshen, IN",
      rating: 5,
      text: "Goshen College semester abroad in Spain — my daughter needed a new passport in 2 weeks. Fast Passport Center got everything done in 4 days. The staff was incredibly helpful walking us through the first-time application process.",
      service: "New Passport (First-Time)",
    },
    {
      name: "Kevin J.",
      location: "Mishawaka, IN",
      rating: 5,
      text: "Family vacation to Cancun with 12 days notice. Needed three passport renewals. Fast Passport Center processed all three in 5 days. Shipped from the UPS Store in Mishawaka — smooth as can be.",
      service: "Family Passport Bundle",
    },
    {
      name: "Patricia S.",
      location: "Elkhart, IN — East Side",
      rating: 5,
      text: "Lost my passport during a business trip to a supplier in Indiana. Had an international flight from Chicago in 7 days. Fast Passport Center replaced it in 48 hours. Incredible response time for a stressful situation.",
      service: "Lost Passport Replacement",
    },
  ],
  facilities: [
    {
      id: "elkhart-1",
      name: "Elkhart Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "111 S 2nd St",
      city: "Elkhart",
      state: "IN",
      zip: "46516",
      phone: "(574) 293-7938",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Downtown Elkhart, near the Elkhart River Riverwalk",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Elkhart acceptance facility. Appointments required — book 1–2 weeks in advance. Convenient downtown location near the Riverwalk and Elkhart Public Library.",
      icon: "ri-mail-line",
    },
    {
      id: "elkhart-2",
      name: "Goshen Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "410 W Pike St",
      city: "Goshen",
      state: "IN",
      zip: "46526",
      phone: "(574) 533-2160",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Goshen, approximately 10 miles southeast of Elkhart",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for Goshen, Goshen College, and southern Elkhart County residents. Good alternative when Elkhart appointments are full.",
      icon: "ri-mail-line",
    },
    {
      id: "elkhart-3",
      name: "Mishawaka Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "310 W 6th St",
      city: "Mishawaka",
      state: "IN",
      zip: "46544",
      phone: "(574) 255-4313",
      hours: "Mon–Fri: 9:00 AM – 5:00 PM",
      distance: "Mishawaka, approximately 12 miles west of Elkhart",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Larger facility with extended hours. Good alternative for western Elkhart County and St. Joseph County residents. Serves Mishawaka and Granger.",
      icon: "ri-mail-line",
    },
    {
      id: "elkhart-4",
      name: "Elkhart County Clerk",
      type: "County Clerk Passport Acceptance",
      address: "101 N Main St",
      city: "Goshen",
      state: "IN",
      zip: "46526",
      phone: "(574) 535-6469",
      hours: "Mon–Fri: 8:00 AM – 4:00 PM",
      distance: "Goshen, Elkhart County Courthouse",
      website: "https://www.elkhartcounty.com/",
      websiteLabel: "Elkhart County",
      notes: "County clerk passport acceptance at the Elkhart County Courthouse in Goshen. Extended morning hours. Call to confirm current passport acceptance hours.",
      icon: "ri-government-line",
    },
    {
      id: "elkhart-5",
      name: "Bristol Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "107 W Vistula St",
      city: "Bristol",
      state: "IN",
      zip: "46507",
      phone: "(574) 848-4928",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Bristol, approximately 10 miles north of Elkhart",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Northern acceptance facility for Bristol and northern Elkhart County residents. Smaller post office — call ahead for appointment availability.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, 2–3 week wait", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 2-hour drive to Chicago (~110 miles)", fpc: "No — ship from Elkhart, courier handles everything" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "RV Industry Travel", agency: "No special trade show support", fpc: "Experienced with RV industry trade show and manufacturing travel deadlines" },
  ],
  mistakes: [
    {
      icon: "ri-time-line",
      title: "Waiting Until the Last Minute",
      description: "RV industry professionals often discover passport issues right before major European trade shows like Caravan Salon Düsseldorf. Routine processing takes 8–11 weeks. Start expedited service at least 6 weeks before international trade events.",
    },
    {
      icon: "ri-image-line",
      title: "Wrong Passport Photo",
      description: "Local photo services in Elkhart and Goshen sometimes produce photos with incorrect backgrounds or sizing. Passport photos must be exactly 2x2 inches on a white background — no exceptions.",
    },
    {
      icon: "ri-car-line",
      title: "Underestimating Chicago Drive Time",
      description: "Driving from Elkhart to the Chicago Passport Agency means navigating the Indiana Toll Road (I-80/90), Chicago Skyway, and downtown Chicago traffic — easily 2.5+ hours each way. Our courier service eliminates this stress entirely.",
    },
    {
      icon: "ri-global-line",
      title: "Not Checking Blank Visa Pages",
      description: "Frequent international business travelers from the RV industry often run out of blank visa pages. The U.S. no longer adds pages to existing passports — you must renew. If you travel often, request the 52-page passport book.",
    },
    {
      icon: "ri-map-pin-2-line",
      title: "Assuming South Bend Has a Passport Agency",
      description: "South Bend does not have a regional passport agency. The nearest are Chicago (2 hours west), Detroit (3 hours east), or Indianapolis (3 hours south). There is no passport agency in northern Indiana.",
    },
    {
      icon: "ri-calendar-line",
      title: "Not Accounting for Trade Show Seasons",
      description: "RV industry trade shows peak in late summer (Düsseldorf Caravan Salon in August/September) and early winter (RVIA National RV Trade Show in Louisville in November/December). Plan passport renewals around these busy periods.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes — from anywhere in Elkhart or Elkhart County." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS or FedEx in Elkhart, Goshen, or Mishawaka." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy — no rejections for Elkhart County documentation errors." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Our registered courier submits to State Department facilities — no 2-hour Chicago drive required." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Elkhart address — trackable every step of the way." },
  ],
  faqs: [
    { q: "How fast can I get an emergency passport in Elkhart, IN?", a: "Fast Passport Center offers emergency passport processing in Elkhart, Indiana in as little as 24–48 hours. Our registered couriers hand-deliver your documents to U.S. Department of State facilities — no need to make the 2-hour drive to the Chicago Passport Agency through unpredictable Chicago traffic." },
    { q: "Does Elkhart have its own passport agency?", a: "No — Elkhart does not have a regional passport agency. The nearest are the Chicago Passport Agency (approximately 110 miles west via I-80/90, about 2 hours) or the Detroit Passport Agency (approximately 180 miles east, about 3 hours). Fast Passport Center's courier service means Elkhart residents never need to make these long drives." },
    { q: "Can you help RV industry professionals with international trade show travel?", a: "Absolutely. Fast Passport Center serves Elkhart County's RV manufacturing community — the RV capital of the world. We understand trade show deadlines (Caravan Salon Düsseldorf, RVIA National RV Trade Show, international supplier visits) and can coordinate expedited services to match your travel schedule." },
    { q: "What airport do Elkhart travelers use for international flights?", a: "South Bend International Airport (SBN) is the closest airport — approximately 25 miles west of Elkhart. For international flights, most Elkhart travelers use Chicago O'Hare (ORD, about 2 hours west) or Chicago Midway (MDW, about 2 hours west). Detroit Metro (DTW) is also an option, about 2.5 hours east." },
    { q: "How much does an expedited passport cost in Elkhart, IN?", a: "Government fees are fixed: $130 for a first-time adult passport book or $130 + $60 expedite fee for a renewed adult passport. Fast Passport Center's service fees vary by processing speed. Contact us for a quote based on your specific departure timeline." },
    { q: "Where can I get passport photos in Elkhart?", a: "Walgreens (multiple locations in Elkhart and Goshen), CVS (1525 E Bristol St, Elkhart), and the UPS Store (505 S Main St, Elkhart) offer passport photo services. Photos must be 2x2 inches on a white background, taken within 6 months." },
    { q: "Does Fast Passport Center serve Goshen College students?", a: "Yes. Fast Passport Center serves Goshen College students, faculty, and staff needing expedited passport services for study abroad, service trips, and international research. Our courier service is fast and reliable for the Goshen community." },
    { q: "What about Mishawaka, Bristol, and other nearby communities?", a: "Absolutely. Fast Passport Center serves all of Elkhart County and the Michiana region including Mishawaka, Bristol, South Bend, Granger, Osceola, Nappanee, Middlebury, and Wakarusa. Our courier service works the same way for everyone throughout northern Indiana." },
  ],
  photoLocations: [
    { name: "Walgreens — Elkhart", address: "1545 E Bristol St, Elkhart, IN 46514", hours: "Mon–Sun: 7AM–10PM", website: "https://www.walgreens.com" },
    { name: "CVS — Elkhart", address: "1525 E Bristol St, Elkhart, IN 46514", hours: "Mon–Sun: 8AM–9PM", website: "https://www.cvs.com" },
    { name: "UPS Store — Elkhart", address: "505 S Main St, Elkhart, IN 46516", hours: "Mon–Fri: 8AM–7PM, Sat: 9AM–5PM", website: "https://www.theupsstore.com" },
    { name: "Walgreens — Goshen", address: "101 W Pike St, Goshen, IN 46526", hours: "Mon–Sun: 7AM–10PM", website: "https://www.walgreens.com" },
  ],
  dmvLocations: [
    { name: "Indiana BMV — Elkhart", address: "3851 County Rd 6, Elkhart, IN 46514", hours: "Mon–Fri: 8:30AM–6:00PM", note: "Indiana Bureau of Motor Vehicles for driver's licenses and REAL ID. Online reservations strongly recommended. Convenient location off County Road 6.", featured: true },
    { name: "Indiana BMV — Goshen", address: "3826 Elkhart Rd, Goshen, IN 46526", hours: "Mon–Fri: 8:30AM–6:00PM", note: "Alternative BMV in Goshen for southern Elkhart County residents. REAL ID processing available.", featured: false },
  ],
  airports: [
    {
      code: "SBN",
      name: "South Bend International Airport",
      distance: "25 miles west of Elkhart via US-20 — approximately 30 minutes",
      address: "4477 Progress Dr, South Bend, IN 46628",
      note: "Closest airport to Elkhart. Limited domestic service with connections through major hubs. No scheduled international flights. Good for domestic connections to international gateways like ORD, DTW, or ATL.",
      flightUrl: "https://flysbn.com/",
      flightLabel: "SBN Flight Info",
      featured: true,
    },
    {
      code: "ORD",
      name: "Chicago O'Hare International Airport",
      distance: "110 miles west of Elkhart via I-80/90 — approximately 2 hours",
      address: "10000 W O'Hare Ave, Chicago, IL 60666",
      note: "Major international hub for Elkhart travelers. United and American Airlines hubs with global connections. The primary international gateway for Elkhart County's RV industry professionals.",
      flightUrl: "https://www.flychicago.com/ohare/",
      flightLabel: "ORD Flight Info",
      featured: false,
    },
    {
      code: "DTW",
      name: "Detroit Metropolitan Airport",
      distance: "180 miles east of Elkhart via I-94 — approximately 2.5 hours",
      address: "Romulus, MI 48174",
      note: "Alternative international airport for Elkhart travelers. Delta hub with extensive domestic and international connections. Good option for flights to Asia and Europe via Delta.",
      flightUrl: "https://www.metroairport.com/",
      flightLabel: "DTW Flight Info",
      featured: false,
    },
  ],
  vitalRecordsLinks: [
    { label: "Elkhart County: Birth & Death Certificates", url: "https://www.in.gov/health/vital-records/", icon: "ri-file-text-line", description: "Indiana Department of Health Vital Records — order birth and death certificates for Elkhart County and all Indiana counties" },
    { label: "Elkhart County Clerk: Marriage Licenses", url: "https://www.elkhartcounty.com/", icon: "ri-heart-line", description: "Elkhart County Clerk — marriage license records for Elkhart and Elkhart County" },
    { label: "Elkhart County: Divorce Decrees", url: "https://www.elkhartcounty.com/", icon: "ri-file-list-3-line", description: "Elkhart County Clerk of Courts — divorce decree records for Elkhart and Elkhart County" },
    { label: "VitalChek Nationwide Service", url: "https://www.vitalchek.com/", icon: "ri-global-line", description: "Order Indiana vital records online through VitalChek for delivery to your Elkhart address" },
  ],
};